import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { KeyboardDatePicker, KeyboardTimePicker, KeyboardDateTimePicker } from '@material-ui/pickers';
import fieldLogic from '../logic/fieldsLogic';
import withMomentTz from '../../../../core/EcrionProvider/withMomentTz';
import useInputRef from './useInputRef';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import StyledText from './StyledTextInput';
import LookupButton from '../components/LookupButton';

var DatePickerText = function DatePickerText(_ref) {
  var margin = _ref.margin,
      description = _ref.description,
      errorMessage = _ref.errorMessage,
      variant = _ref.variant,
      InputProps = _ref.InputProps,
      keyboardIcon = _ref.keyboardIcon,
      id = _ref.id,
      showLookupButton = _ref.showLookupButton,
      rest = _objectWithoutProperties(_ref, ["margin", "description", "errorMessage", "variant", "InputProps", "keyboardIcon", "id", "showLookupButton"]);

  return React.createElement(StyledText, Object.assign({}, rest, {
    id: id,
    InputProps: {
      endAdornment: React.createElement(React.Fragment, null, InputProps.endAdornment, showLookupButton && React.createElement(LookupButton, {
        fieldId: id
      }))
    },
    variant: variant,
    helperText: errorMessage || description || React.createElement(Typography, null, " ")
  }));
};

var createMask = function createMask(dateFormat, timeFormat, separator) {
  return '';
};

var replaceSeparator = function replaceSeparator(format, separator) {
  if (!format || !separator) return format;
  return format.replace(/\//g, separator);
};

var createPlaceholderForDateOrDateTime = function createPlaceholderForDateOrDateTime(format, type, timeFormat) {
  var isAmPm = timeFormat && timeFormat.startsWith('HH') ? false : true;
  if (type === 'datetime' && isAmPm) return format + ' HH:mm a';
  if (type === 'datetime' && !isAmPm) return format + ' HH:mm';
  return format;
};

var sanitizeFormat = function sanitizeFormat(format, separator) {
  // default format
  if (!format) return 'DD/MM/YYYY';
  var sanitizedFormat = format.replace(/y/g, 'Y').replace(/m/g, 'M').replace(/d/g, 'D'); // format sanitization to be compliant with

  return replaceSeparator(sanitizedFormat, separator);
};

var FormFieldDate = function FormFieldDate(props) {
  var fieldId = props.fieldId,
      value = props.value,
      dispatch = props.dispatch,
      onChange = props.onChange;
  var type = props.type,
      active = props.active,
      error = props.error,
      readonly = props.readonly,
      description = props.description;
  var futureDatesOnly = props.futureDatesOnly,
      pastDatesOnly = props.pastDatesOnly,
      lowerBound = props.lowerBound,
      upperBound = props.upperBound;
  var dateFormat = props.dateFormat,
      timeFormat = props.timeFormat,
      separator = props.separator,
      mask = props.mask,
      variant = props.variant;
  var lookupVisiblity = props.lookupVisiblity,
      xpath = props.xpath;

  var _useInputRef = useInputRef(active),
      _useInputRef2 = _slicedToArray(_useInputRef, 2),
      inputRef = _useInputRef2[0],
      refNode = _useInputRef2[1];

  var showLookupButton = xpath && lookupVisiblity !== 'hide';

  var onChangeDate = function onChangeDate(date, value) {
    if (date && !date.isValid()) return fieldLogic.onChange(fieldId, 'invalidDate', dispatch);
    var val = null;
    if (date && type === 'date') val = date.format('YYYY-MM-DD');

    if (date && type === 'time') {
      var pickedTime = date.format('HH:mm:ss');
      var timeValue = createDateTimeFromTime(pickedTime); //always use UTC for times to avoid DST skips

      val = moment.tz(timeValue, 'UTC').format('HH:mm:ss');
    }

    if (date && type === 'datetime') val = date.utcOffset(0, true).toISOString();
    if (onChange) return onChange(val);
    fieldLogic.onChange(fieldId, val, dispatch);
  };

  var onFocus = function onFocus() {
    if (!fieldLogic || !dispatch) return;
    fieldLogic.onFocus(fieldId, dispatch);
  };

  var onBlur = function onBlur() {
    if (!fieldLogic || !dispatch) return;
    fieldLogic.onBlur(fieldId, dispatch);
  };

  var timePickerProps = {
    showLookupButton: showLookupButton,
    id: fieldId,
    error: !!error,
    errorMessage: error,
    inputVariant: variant,
    disabled: readonly,
    onChange: onChangeDate,
    onFocus: onFocus,
    onBlur: onBlur,
    description: description,
    TextFieldComponent: DatePickerText,
    KeyboardButtonProps: {
      style: {
        padding: 0
      }
    },
    onOpen: function onOpen() {
      refNode && refNode.focus();
    }
  };

  var createDateTimeFromTime = function createDateTimeFromTime(time) {
    var datetime = moment.utc("1900-01-01 ".concat(time), 'YYYY-MM-DD HH:mm:ss');
    var str = datetime.toISOString();
    return str;
  };

  var datePickerProps = {};
  if (futureDatesOnly) datePickerProps.disablePast = true;else if (lowerBound) datePickerProps.minDate = moment.utc(lowerBound).format();
  if (pastDatesOnly) datePickerProps.disableFuture = true;else if (upperBound) datePickerProps.maxDate = moment.utc(upperBound).format();
  datePickerProps.format = sanitizeFormat(dateFormat, separator);
  datePickerProps.placeholder = createPlaceholderForDateOrDateTime(replaceSeparator(dateFormat, separator), type, timeFormat);
  datePickerProps.mask = createMask(dateFormat, timeFormat, separator);
  if (type === 'datetime' && timeFormat) datePickerProps.format += ' ' + timeFormat;
  var ampm = timeFormat && timeFormat.startsWith('HH') ? false : true;

  if (type === 'time') {
    var timeValue = null;

    if (value) {
      timeValue = createDateTimeFromTime(value); // adjust value to be ISO
      // this allows the user to pass a "03:00:00 AM" as value

      timeValue = moment.tz(timeValue, 'UTC');
      timeValue.keepTime = true;
    }

    return React.createElement(KeyboardTimePicker, Object.assign({}, timePickerProps, {
      format: timeFormat,
      ampm: ampm,
      value: timeValue || null,
      inputRef: inputRef
    }));
  }

  if (type === 'date') {
    // ensure that value is in utc
    var utcValue = value && moment.utc(value).format(); // use a moment object that will the actual time

    var momentValue = utcValue && moment.tz(utcValue, 'UTC');
    if (momentValue) momentValue.keepTime = true;
    return React.createElement(KeyboardDatePicker, Object.assign({}, timePickerProps, datePickerProps, {
      value: momentValue || null,
      inputRef: inputRef
    }));
  }

  if (type === 'datetime') {
    return React.createElement(KeyboardDateTimePicker, Object.assign({}, timePickerProps, datePickerProps, {
      ampm: ampm,
      value: value || null,
      inputRef: inputRef
    }));
  }

  return null;
};

export default React.memo(withMomentTz(FormFieldDate));